import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../Application';
import {apiClient} from '../../services/api'
import SetupView from '../../ui/views/Setup/Setup';
import NoDevice from "../../ui/views/Dialog/NoDevice";
import {whiteLabelData} from "../../ui/theme"
import {parseAreaSlidersToBitMask,
  parseDIfunctionNameToNumber,
  parseDOfunctionNameToNumber,
  parseAIfunctionNameToNumber,
  parseAItypeNameToNumber,
  parseVentSysNameToNumber,
  parseVentSysAreaNameToNumber
} from "../../utils/elsc_utils"

import {fetchDevices} from "../../connectors/Devices/actions";
import log from 'loglevel'
import { t } from 'i18next';

var pageTitle = ""
const title = whiteLabelData.name


const mapStateToProps = state => ({
  title: state.application.title,
  map: state.devices.map,
  currentDevice: (state.devices.map[state.devices.active] || { setupData: {} }),
  setupData: (state.devices.map[state.devices.active].state.varlist),
  currentDeviceId: (state.devices.map[state.devices.active] || { setupData: {} }).deviceid,
  currentDeviceName: (state.devices.map[state.devices.active] || { setupData: {} }).label
});

const mapDispatchToProps = dispatch => ({
  fetchDevices: () => dispatch(fetchDevices()),
});

/**
 * Setup
 */
class Setup extends PureComponent {
  static propTypes = {
  }

  static defaultProps = {
  }

  constructor(props) {
    super(props)
    this.state.deviceVarList = this.props.setupData
  }

  state = {
    deviceVarList: []
  }

  componentDidMount() {

  }

  componentWillMount() {
    pageTitle = t('PageTitles.setup')
    this.secondLoad()
  }

  secondLoad = () => {
    var data = { deviceid: this.props.currentDeviceId }
    log.debug("SECONDLOAD")
    apiClient.post('control/settings/store', data)
      .then(res => {
        if (res.status === 200) {
          log.debug("STATE UPDATE CMD OK")
          this.props.fetchDevices()
        }
      })
      .then(()=> {
        setTimeout(() =>{
          this.props.fetchDevices()
            log.debug("2 Seconds LATER")

      }, 2000)
      })
  }

  onShockVentilationChange = (newSV) => {
    log.debug(newSV)
    log.debug(this)
    log.debug(this.props)
    var data = {deviceid: this.props.currentDeviceId, shockVentilation: newSV}
    log.debug(data)
    apiClient.post('control/setup/changeshockventilation', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
      }
    })
    .catch((err) => {
      log.error("Error on Shock Ventilation Change", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")
  }

  onDIsetupChange = (areas, funName) => {
    log.debug(areas)
    log.debug(funName)
    log.debug(this.props)
    var data = { deviceid: this.props.currentDeviceId, diVector: parseAreaSlidersToBitMask(areas), functionNumber: parseDIfunctionNameToNumber(funName) }
    log.debug(data)
    apiClient.post('control/setup/changedisetup', data)
      .then((res) => {
        if (res.status === 200) {
          log.debug("ok")
          log.debug(res)
        }
      })
      .catch((err) => {
        log.error("Error on DI Setup Change", err.status)
        log.error(err.json)
      })
    log.debug("after try catch")
  }

  onDOsetupChange = (areas, funName) => {
    log.debug(areas)
    log.debug(funName)
    log.debug(this.props)
    var data = { deviceid: this.props.currentDeviceId, doVector: parseAreaSlidersToBitMask(areas), functionNumber: parseDOfunctionNameToNumber(funName) }
    log.debug(data)
    apiClient.post('control/setup/changedosetup', data)
      .then((res) => {
        if (res.status === 200) {
          log.debug("ok")
          log.debug(res)
        }
      })
      .catch((err) => {
        log.error("Error on DO Setup Change", err.status)
        log.error(err.json)
      })
    log.debug("after try catch")
  }

  onAIsetupChange = (areas, funName, funType) => {
    log.debug(areas)
    log.debug(funName)
    log.debug(this.props)
    var data = { deviceid: this.props.currentDeviceId, aiVector: parseAreaSlidersToBitMask(areas), functionNumber: parseAIfunctionNameToNumber(funName), funType : parseAItypeNameToNumber(funType)}
    log.debug(data)
    apiClient.post('control/setup/changeaisetup', data)
      .then((res) => {
        if (res.status === 200) {
          log.debug("ok")
          log.debug(res)
        }
      })
      .catch((err) => {
        log.error("Error on AI Setup Change", err.status)
        log.error(err.json)
      })
    log.debug("after try catch")
  }

  onAIcurveChange = (curveParams) => {
    log.debug(curveParams)

    log.debug(this.props)
    var data = { deviceid: this.props.currentDeviceId, curveParams: curveParams }
    log.debug(data)
    apiClient.post('control/setup/changeaicurve', data)
      .then((res) => {
        if (res.status === 200) {
          log.debug("ok")
          log.debug(res)
        }
      })
      .catch((err) => {
        log.error("Error on AI Curve Change", err.status)
        log.error(err.json)
      })
    log.debug("after try catch")
  }

  onFactoryReset = () => {
    var data = { deviceid: this.props.currentDeviceId }

    apiClient.post('control/setup/factoryreset', data)
      .then((res) => {
        if (res.status === 200) {
          log.debug("ok")
          log.debug(res)
        }
      })
      .catch((err) => {
        log.error("Error on Factory Reset", err.status)
        log.error(err.json)
      })
    log.debug("after try catch")

  }

  onSystemsChange = (systems) => {
    log.debug(systems)

    let numericalSystems = []

    for (let index = 0; index < 6; index++) {

      numericalSystems[index] = [parseVentSysNameToNumber(systems[index + 1].type), parseVentSysAreaNameToNumber(systems[index + 1].installed)]

    }

    log.debug(numericalSystems)
    var data = { deviceid: this.props.currentDeviceId, systemsSetup: numericalSystems }
    apiClient.post('control/setup/changesystems', data)
      .then((res) => {
        if (res.status === 200) {
          log.debug("ok")
          log.debug(res)
        }
      })
      .catch((err) => {
        log.error("Error on Systems Change", err.status)
        log.error(err.json)
      })
    log.debug("after try catch")
  }

  render() {
    if (this.props.currentDevice === undefined) {
      return <NoDevice
      title={pageTitle}
      ></NoDevice>;
    }
    return (
      <SetupView
      title={pageTitle}
      setupData ={this.props.currentDevice.state.varlist}
      onMyLoad ={this.secondLoad}
      onSystemsChange={this.onSystemsChange}
      onShockVentilationChange={this.onShockVentilationChange}
      onDIsetupChange={this.onDIsetupChange}
      onDOsetupChange={this.onDOsetupChange}
      onAIsetupChange={this.onAIsetupChange}
      onFactoryReset={this.onFactoryReset}
      onAIcurveChange ={this.onAIcurveChange}

      />
    );
  }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(Setup)), title);
